<mat-dialog-content class="mat-typography">
    <h3 [innerHTML]="data.message | safeHtml"></h3>
</mat-dialog-content>
<div mat-dialog-actions class="flex row end-center">
    <button mat-button [mat-dialog-close]="true" color="primary">Ok</button>
</div>